import { ActionCreator } from 'redux';
import { Export } from '@dev/ee-api/ee-api-models';

import {
    LoadExportsAction,
    LoadExportsErrorAction,
    LoadExportsStartAction,
    LoadExportsSuccessAction,
    ExportsCount,
    ExportsPayload,
    FilterExportsAction,
    DeleteExportsAction,
    DeleteExportsStartAction,
    DeleteExportsErrorAction,
    DeleteExportsSuccessAction,
    SearchExportsAcion,
    RestoreDefaultStoreAction,
    ApiExportsTypes,
} from './types';
import { store } from '@shared-store/shared-store';

export const LoadExports: ActionCreator<LoadExportsAction> = (params?: ExportsPayload): LoadExportsAction => {
    return {
        type: ApiExportsTypes.FETCH_EXPORTS,
        payload: params,
    };
};

export const StartLoadingExports: ActionCreator<LoadExportsStartAction> = (): LoadExportsStartAction => ({
    type: ApiExportsTypes.FETCH_EXPORTS_START,
});

export const LoadingExportsSuccess: ActionCreator<LoadExportsSuccessAction> = (
    exports: Export[],
    counts: ExportsCount
): LoadExportsSuccessAction => ({
    type: ApiExportsTypes.FETCH_EXPORTS_SUCCESS,
    payload: {
        exportsList: exports,
        counts,
    },
});

export const LoadingExportsError: ActionCreator<LoadExportsErrorAction> = (): LoadExportsErrorAction => ({
    type: ApiExportsTypes.FETCH_EXPORTS_ERROR,
});

export const FilterExports: ActionCreator<FilterExportsAction> = (params?: ExportsPayload): FilterExportsAction => {
    const activePage = store.getState().exports.activePage;

    if (activePage > 1) {
        params.activePage = 1;
    }

    return {
        type: ApiExportsTypes.FILTER_EXPORTS,
        payload: params,
    };
};

export const SearchExports: ActionCreator<SearchExportsAcion> = (params?: ExportsPayload): SearchExportsAcion => {
    const activePage = store.getState().exports.activePage;

    if (activePage > 1) {
        params.activePage = 1;
    }

    return {
        type: ApiExportsTypes.SEARCH_EXPORTS,
        payload: params,
    };
};

export const DeleteExport: ActionCreator<DeleteExportsAction> = (id: string): DeleteExportsAction => ({
    type: ApiExportsTypes.DELETE_EXPORTS,
    payload: {
        id,
    },
});

export const DeleteExportStart: ActionCreator<DeleteExportsStartAction> = (): DeleteExportsStartAction => ({
    type: ApiExportsTypes.DELETE_EXPORTS_START,
});

export const DeleteExportError: ActionCreator<DeleteExportsErrorAction> = (): DeleteExportsErrorAction => ({
    type: ApiExportsTypes.DELETE_EXPORTS_ERROR,
});

export const DeleteExportSuccess: ActionCreator<DeleteExportsSuccessAction> = (): DeleteExportsSuccessAction => ({
    type: ApiExportsTypes.DELETE_EXPORTS_SUCCESS,
});

export const RestoreDefaultStore: ActionCreator<RestoreDefaultStoreAction> = (): RestoreDefaultStoreAction => ({
    type: ApiExportsTypes.RESTORE_DEFUALT_STORE,
});
